import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "spinner", "clearButton"]

    static values = {
        delay: { type: Number, default: 300 },
        minLength: { type: Number, default: 2 },
        submitOnClear: { type: Boolean, default: true }
    }

    connect() {
        this.timeout = null
        this.lastValue = this.inputTarget.value || ""

        this.updateUI()

        document.addEventListener(
            "turbo:before-stream-render",
            this.hideSpinner
        )
    }

    disconnect() {
        clearTimeout(this.timeout)
        document.removeEventListener(
            "turbo:before-stream-render",
            this.hideSpinner
        )
    }

    // --------------------------------------------------
    // Actions
    // --------------------------------------------------

    search() {
        const value = this.inputTarget.value.trim()

        this.updateUI()

        if (value.length < this.minLengthValue) return
        if (value === this.lastValue) return

        this.lastValue = value
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            this.showSpinner()
            this.element.requestSubmit()
        }, this.delayValue)
    }

    clear() {
        this.inputTarget.value = ""
        this.lastValue = ""
        this.updateUI()

        if (this.submitOnClearValue) {
            this.showSpinner()
            this.element.requestSubmit()
        }
    }

    // --------------------------------------------------
    // UI helpers
    // --------------------------------------------------

    updateUI() {
        const hasValue = this.inputTarget.value.length > 0
        this.clearButtonTarget.classList.toggle("hidden", !hasValue)
    }

    showSpinner = () => {
        this.spinnerTarget.classList.remove("hidden")
        this.clearButtonTarget.classList.add("hidden")
    }

    hideSpinner = () => {
        this.spinnerTarget.classList.add("hidden")
        this.updateUI()
    }
}
